class LocationAdd {
  constructor(data = {}) {
    this.idUbicacion = data.idUbicacion || 0;
    this.codigo = data.codigo || "";
    this.idUbicacionTipo = data.idUbicacionTipo || 0;
    this.ubicacionTipo = data.ubicacionTipo || "";
    this.nombre = data.nombre || "";
    this.idPais = data.idPais || 0;
    this.estado = data.estado || "";
    this.ciudad = data.ciudad || "";
    this.localidad = data.localidad || "";
    this.colonia = data.colonia || "";
    this.calle = data.calle || "";
    this.codigoPostal = data.codigoPostal || "";
    this.numeroExterior = data.numeroExterior || "";
    this.numeroInterior = data.numeroInterior || "";
    this.numeroTelefono = data.numeroTelefono || "";
    this.email = data.email || "";
    this.descripcion = data.descripcion || "";
    this.horario = data.horario || "";
    this.rfc = data.rfc || "";
    this.estatus = data.estatus || true;
    this.ubicacionContactos = data.ubicacionContactos || [];
  }
}

class LocationEdit {
  constructor(data = {}) {
    this.idUbicacion = data.idUbicacion || 0;
    this.codigo = data.codigo || "";
    this.idUbicacionTipo = data.idUbicacionTipo || 0;
    this.ubicacionTipo = data.ubicacionTipo || "";
    this.nombre = data.nombre || "";
    this.idPais = data.idPais || 0;
    this.estado = data.estado || "";
    this.ciudad = data.ciudad || "";
    this.localidad = data.localidad || "";
    this.colonia = data.colonia || "";
    this.calle = data.calle || "";
    this.codigoPostal = data.codigoPostal || "";
    this.numeroExterior = data.numeroExterior || "";
    this.numeroInterior = data.numeroInterior || "";
    this.numeroTelefono = data.numeroTelefono || "";
    this.email = data.email || "";
    this.horario = data.horario || "";
    this.rfc = data.rfc || "";
    this.descripcion = data.descripcion || "";
    this.estatus = data.estatus || true;
    this.ubicacionContactos = data.ubicacionContactos || [];
  }
}
class ubicacionContactos {
  constructor(data = {}) {
    this.idUbicacionContacto = data.idUbicacionContacto || 0;
    this.idUbicacion = data.idUbicacion || 0;
    this.idContacto = data.idContacto || 0;
    this.correo = data.correo || "";
    this.envioCorreo = data.envioCorreo || false;
    this.estatus = data.estatus || true;
  }
}
export { LocationEdit, LocationAdd,ubicacionContactos };
